import script from "./PaidSubscriptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaidSubscriptions.vue?vue&type=script&setup=true&lang=ts"

import "./PaidSubscriptions.vue?vue&type=style&index=0&id=4e645286&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e645286"]])

export default __exports__